export default "__VITE_ASSET__CacM2IGC__"